import { FormsModule, PatternValidator } from '@angular/forms';
import {
  Component, OnInit, Inject, Injectable, CUSTOM_ELEMENTS_SCHEMA, NgModule,
  Input//, trigger, state, style, transition, animate, keyframes,
} from '@angular/core';
//Rewrite Angular HTTP service after update
//import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import * as _ from 'underscore';
import { CommonSerivce } from '../shared/services/common.service'
import { UserService } from '../shared/services/user.service';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { GrowlModule } from 'primeng/growl';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { RadioButtonModule } from 'primeng/radiobutton';
import { EditorModule } from 'primeng/editor';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { DatePipe } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { ToastModule } from 'primeng/toast';
import { Console } from 'console';
import * as XLSX from "xlsx-js-style";


@Component({
  selector: 'case',
  styleUrls: ['../shared/share.component.css'],
  providers: [CommonSerivce, UserService, DatePipe, ConfirmationService,],
  templateUrl: './case.component.html'
})


export class CaseComponent {

  /*
      RecordList - Search result list
      SelectedRecordList - User selected record (Multiple) in the result table
      SelectedRecord - User selected record (Single) for edition
  */

  public CaseRecordList: ICase[];
  //public FormattedCaseRecordList: ICase[];
  public SelectedCaseRecordList: ICase[];
  public SelectedCaseRecord: ICase;
  public ActivityRecordList: ICaseActivity[];
  public SelectedActivityRecordList: ICaseActivity[];
  public SelectedActivityRecord: ICaseActivity;
  public SelectedAttachmentRecord: IAttachmentValue;
  public InputErrorMsg: Message[] = [];
  public TableConfig: ITableConfig;

  //  Hold the value of the user inputted search field, to be used for searching
  public SearchFieldHolder: any;
  public SearchStaffFieldHolder: any;

  //
  public uploadAttachment: boolean = false;
  public record: any;

  //Code value list for List Box, add required code value list
  public Case_DomainList: IDomainValue[];
  public Case_CategoryList: ICodeValue[];
  public Case_SubCategory1List: ICodeValue[];
  public Case_SubCategory2List: ICodeValue[];
  public Case_SubCategory3List: ICodeValue[];
  public Case_SeverityList: ICodeValue[];
  public Case_ServiceTypeList: ICodeValue[];
  public Case_SourceList: ICodeValue[];
  public Case_CaseStatusList: ICodeValue[];
  public Case_AssigneeList: ICodeValue[];
  public Case_RequestUserList: IDomainUserValue[];
  public Case_EndUserList: IDomainUserValue[];
  public AttachmentList: IAttachmentValue[];
  public Case_ReturnCode: string = "";
  public BusinessUnitList: ICodeValue[];
  public CaseComplexityList: ICodeValue[];

  public NextNumberOutput: INextNumber;
  public GenNextNumberFieldHolder: IGenNextNumber;

  //excel variable
  uploadFile: File;
  strLine: string;
  excelRow: string[] = [];
  SheetNames = [];
  Sheets = {};

  cellList: string[];
  lastRowNumber: number;
  currentProcessRow: number = -1;
  currentProcessColumn: number = -1;
  rangeFromColumn: number = -1;
  rangeFromRow: number = -1;
  rangeToColumn: number = -1;
  rangeToRow: number = -1;
  //excel variable - End


  /*
      sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
      softF - define the sorting field name
  */
  sortO: number = 0;
  sortF: string = 'id';

  public loggedInType: string = "";
  public loggedInCompanyCode: string = "";
  public loggedInUser: string = "";

  //globalFilterValue: string = "";
  public globalFilterValue1: string = "";
  public globalFilterValue2: string = "";
  public globalFilterValue3: string = "";
  public globalFilterValue4: string = "";

  /*
      Major control variables
          FormTitle - Initial Form Title for the landing form
          PrimaryApiPath - Path for the API controller per component 
          ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
          ShowUploadForm - control whether to show Upload form
          AutoReload - control auto reload component
          
  */
  FormTitle: String = "Work With Case";
  FormAccessRight: String = "NA";
  PrimaryApiPath: string = "api/BcpCase/";
  ListValueApiPath: string = "api/BcpListValue/";
  ActivityApiPath: string = "api/BcpCaseActivity/";
  AttachmentPath: string = "api/BcpAttachment/";
  SeverityPath: string = "api/BcpSeverityServiceLevel/";
  DisabledDatePath: string = "api/BcpCalendarDateDisableList/";
  SendEmailPath: string = "api/BcpEmailService/";
  EmailRecipientsPath: string = "api/BcpEmailRecipients/";
  TableSequenceApiPath: string = "api/BcpTableSequence/";

  ShowEditForm: Boolean = false;
  ShowAddForm: Boolean = false;
  ShowUploadForm: Boolean = false;
  AutoReload: Boolean = true;
  SuccessfulSave: Boolean = false;
  SuccessUpload: Boolean = false;
  ShowDialog: Boolean = false;
  public saveButton: Boolean = true;
  scrollHeight: string = "";
  scrollWidth: string = "";
  public AttachmentCount: string = "0";
  public CaseRecordCount: number = 0;
  public CaseListCodeCount: number = 0;
  public CaseRecordCurrentCount: number = 0;
  public CaseListCodeCurrentCount: number = 0;
  public CurrentForm: string = "BcpCase";
  AttachmentAutoReload: Boolean = true;
  checkedError: string = "";

  httpOriginalUrl: String;
  stringifyValue = "";
  stringifyUploadValue = "";
  httpHeaders = new Headers();
  isLoggedIn: boolean = false;
  dateFormat: String = "yy-mm-dd";

  arrayBuffer: any;

  cachedExpiryDate: String = "";

  public leadingPad: number = 4;
  public updateMode: string = "";
  public nextNumber: number;
  public formattedCaseNo: string = "";
  public convertedCaseNo: string = "";

  //Display Warning/ Error Message
  public searchErrorMsgs: Message[] = [];
  public confirmMsgs: Message[] = [];
  public resultMsgs: Message[] = [];

  //Control Complete Date Calendar Readonly Variable
  public completeDateReadonly: boolean = true;

  //For display Edit and Delete Images
  //public imgEdit = require("../shared/Images/edit.gif");
  //public imgDelete = require("../shared/Images/delete.gif");

  //for animation status
  //animStatus: string = 'inactive';

  //Rewrite Data Table Code
  public caseCols: any;
  public attachmentCols: any;

  //20210525 Enhancement Start - Row Expansion to display case activities - Jelly
  public latestActivitiesList: ICaseActivity[];
  public latestActivityCols: any;
  //20210525 Enhancement End

  //20211005 Enhancement Start - Auto Update Target Date when Severity updated
  public numericCheck: boolean = false;
  //20211005 Enhancement End

  //20211005 Enhancement Start - Update Date Field to DateTime Field
  public formattedDate: String;
  //20211005 Enhancement End

  //20220617 Enhancement Start - Enable Send out Email Function
  public activityEmailDisable: boolean = true;
  public emailList: INotifyEmailList[];
  public emailValidResult: boolean = false;
  //public emailDialogVisible: boolean = false;
  public emailReturnMsg: Message[] = [];
  public emailContext: ICaseActivity;
  public emailReturnStatus: boolean = false;
  public defaultEmailRecipients: string = "";

  public activityAction: string = "";
  public savingActivity: boolean = false;
  public savingActivityMsg: string = "";
  //20220617 Enhancement End

  //20221213 Enhancement Start - Send Email when Case Status Changed - Jelly
  public originalCaseStatus: string = "";
  public updatedCaseStatus: string = "";
  public caseStatusEmail: ICaseStatusEmail;
  //20221213 Enhancement End

  hkHolidays = [
    '2025-01-01',
    '2025-01-29',
    '2025-01-30',
    '2025-01-31',
    '2025-04-18',
    '2025-04-21',
    '2025-05-01',
    '2025-05-05',
    '2025-07-01',
    '2025-10-01',
    '2025-10-07',
    '2025-10-29',
    '2025-12-25',
    '2025-12-26',
    // add other holidays here
  ];

  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string, private bcp: CommonSerivce, private datePipe: DatePipe, private confirmationService: ConfirmationService) {
    //Rewrite Angular HTTP service after update
    //this.httpHeaders = this.bcp.getHttpHeader();

    this.httpOriginalUrl = originUrl;

    //this.PrimaryApiPath = originUrl + this.PrimaryApiPath;
    //this.ListValueApiPath = originUrl + this.ListValueApiPath;
    //this.ActivityApiPath = originUrl + this.ActivityApiPath;

    this.clearAllMessage();
    this.isLoggedIn = this.bcp.getLoginStatus();
    this.FormAccessRight = this.bcp.getAccessRightByProcess('CASE');

    this.loggedInType = this.bcp.getCurrentUserAccountType();
    this.loggedInCompanyCode = this.bcp.getCurrentCompanyCode();
    this.loggedInUser = this.bcp.getCurrentLoginUser();

    //get all list value for drop down list
    this.getCaseDomainList();
    this.fetchDropDownValuebyDomian("Search", this.bcp.getCurrentDomainId());

    //get all records when initialize the page        
    this.getCaseData();
    //this.FormattedCaseRecordList.sort((a, b) => (a.id < b.id ? -1 : 1));                       

    //this.resetSearchField();
    this.initializeSelectedRow();
    this.FormTitle = "Work With Case";
    //this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.ShowUploadForm = false;

    //Get Value from URL Path passing from Manu Bar
    /*var currentPath = document.location.toString().toLowerCase();
    var paraName = 'showaddform='
    var stringLength = currentPath.indexOf(paraName);
    var paraLength = paraName.length;
    this.ShowAddForm = JSON.parse(currentPath.substr(stringLength + paraLength));*/

    this.scrollHeight = this.bcp.getDataTableHeight(0);//parameter: # of rows used for header search field
    this.scrollWidth = this.bcp.getDataTableWidth();

    //Rewrite Data Table Code
    //Case Column Header
    this.caseCols = [
      { field: 'action', header: 'Action', width: '130', size: '20' },
      { field: 'expand', width: '60', size: '5' },
      //{ field: 'id', header: 'ID', width: '100', size: '5' },
      { field: 'caseNumber', header: 'Case No.', width: '120', size: '10' },
      { field: 'domainId', header: 'Domain', width: '120', size: '5' },
      { field: 'caseStatusDesc', header: 'Status', width: '100', size: '5' },
      { field: 'assignedToDesc', header: 'Assigned To', width: '130', size: '10' },
      { field: 'subject', header: 'Subject', width: '300', size: '10' },
      { field: 'longDescription', header: 'Description', width: '400', size: '10' },
      { field: 'clientReferenceNumber', header: 'Client Reference', width: '100', size: '10' },
      { field: 'severityDesc', header: 'Severity', width: '150', size: '10' },
      { field: 'serviceTypeDesc', header: 'Service Type', width: '150', size: '10' },
      { field: 'caseComplexityDesc', header: 'Complexity', width: '120', size: '10' },
      { field: 'source', header: 'Source', width: '200', size: '10' },
      { field: 'categoryDesc', header: 'Category', width: '200', size: '10' },
      { field: 'subCat1Desc', header: 'Sub-Category1', width: '200', size: '10' },
      { field: 'subCat2Desc', header: 'Sub-Category2', width: '200', size: '10' },
      { field: 'requestUser', header: 'Request User', width: '200', size: '10' },
      { field: 'issueDate', header: 'Issue Date', width: '200', size: '10' },
      { field: 'responseDate', header: 'Response Date', width: '200', size: '10' },
      { field: 'resolutionDate', header: 'Resolution Date', width: '200', size: '10' },
      { field: 'completeDate', header: 'Complete Date', width: '200', size: '10' },
      { field: 'updateDate', header: 'Update Date', width: '200', size: '10' },
      { field: 'fiscalYear', header: 'Year', width: '100', size: '10' },
      { field: 'responseHour', header: 'Response Hour', width: '100', size: '10' },
      { field: 'resolutionHour', header: 'Resolution Hour', width: '100', size: '10' },
    ];

    //Case Attachment Column Header
    this.attachmentCols = [
      { field: 'actions', header: 'Actions', width: '60', size: '5' },
      { field: 'id', header: 'Id', width: '60', size: '5' },
      { field: 'sourceRecordId', header: 'Source Record Id', width: '100', size: '5' },
      { field: 'displayName', header: 'File Name', width: '100', size: '5' },
      { field: 'createDate', header: 'Create Date', width: '100', size: '5' }
    ];

    //20210525 Enhancement Start - Row Expansion to display case activities - Jelly
    this.latestActivityCols = [
      { field: 'caseNumber', header: 'Case Number', width: '20', size: '5' },
      { field: 'createDate', header: 'Create Date', width: '30', size: '5' },
      { field: 'createUser', header: 'Create User', width: '20', size: '5' },
      { field: 'activityDetails', header: 'Activity Details', width: '80', size: '5' },
      { field: 'notifyUser', header: 'Notify User Flag', width: '20', size: '5' },
      { field: 'notifyUserList', header: 'Notify User List', width: '20', size: '5' },
      { field: 'updateDate', header: 'Update Date', width: '30', size: '5' },
      { field: 'updateUser', header: 'Update User', width: '20', size: '5' }
    ]
    //20210525 Enhancement End
  }


  //-----------------------------------------------------------------------------
  //                      Fetch List Data for Drop Down List
  //-----------------------------------------------------------------------------

  fetchDropDownValuebyDomian(Form, selectedDomain) {

    if (selectedDomain != "BCP") {
      this.getCaseCategoryList(Form, selectedDomain);
      this.getCaseSubCategory1List(Form, selectedDomain);
      this.getCaseSubCategory2List(Form, selectedDomain);
      this.getCaseSubCategory3List(Form, selectedDomain);
      this.getBusinessUnitList(Form, selectedDomain);
    } else {
      this.getCaseCategoryList(Form, "All");
      this.getCaseSubCategory1List(Form, "All");
      this.getCaseSubCategory2List(Form, "All");
      this.getCaseSubCategory3List(Form, "All");
      this.getBusinessUnitList(Form, "All");
    }

    this.getCaseAssigneeList(Form, 'BCP');
    this.getCaseStatusList(Form, 'BCP');
    this.getCaseSeverityList(Form, 'BCP');
    this.getCaseServiceTypeList(Form, 'BCP');
    this.getCaseSourceList(Form, 'BCP');
    this.getCaseComplexityList(Form, 'BCP');
  }

  getCaseDomainList() {
    this.http.get("api/BcpDomain/DomainList", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_DomainList = result;
      });
  }


  getCaseCategoryList(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/CATEGORY", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_CategoryList = result;
      });
  }


  getCaseSubCategory1List(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/SUBCATEGORY1", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_SubCategory1List = result;
      });
  }


  getCaseSubCategory2List(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/SUBCATEGORY2", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_SubCategory2List = result;
      });
  }


  getCaseSubCategory3List(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/SUBCATEGORY3", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_SubCategory3List = result;
      });
  }


  getBusinessUnitList(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/BU", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.BusinessUnitList = result;
      });
  }


  getCaseStatusList(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/STATUS", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_CaseStatusList = result;
      });
  }


  getCaseSeverityList(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/SEVERITY", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_SeverityList = result;
      });
  }


  getCaseServiceTypeList(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/SERVICE_TYPE", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_ServiceTypeList = result;
      });
  }


  getCaseComplexityList(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/CASE_CPLEX", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CaseComplexityList = result;
      });
  }


  getCaseSourceList(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/SOURCE", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_SourceList = result;
      });
  }


  getCaseAssigneeList(Form, selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode3/" + selectedDomain + "/ASSIGNEE", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.Case_AssigneeList = result;
      });
  }


  getCaseRequestUserList() {
    this.http.get("api/BcpUserProfile/ByDomainId/" + this.bcp.getCurrentDomainId(), this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_RequestUserList = result.json();
        this.Case_RequestUserList = result;
      });
  }


  getCaseEndUserList() {
    this.http.get("api/BcpUserProfile/ByDomainId/" + this.bcp.getCurrentDomainId(), this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_EndUserList = result.json();
        this.Case_EndUserList = result;
      });
  }






  //-----------------------------------------------------------------------------
  //                            Fetch/ Search Data
  //-----------------------------------------------------------------------------

  getCaseData() {
    this.AutoReload = true;

    this.http.get(this.PrimaryApiPath + "GetAllOpen/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentDataRole(), this.bcp.getHttpOptions())
      //.map((response: Response) => response.json())
      .subscribe((data: any[]) => {
        this.CaseRecordList = data;
        this.CaseRecordCount = this.CaseRecordList.length;

        if (this.CaseRecordList.length > 0) {
          this.applyGlobalFilter();
          for (var i = 0; i < this.CaseRecordList.length; i++) {
            //Format Date to YYYY-MM-DD
            if (this.CaseRecordList[i].createDate != null) {
              this.CaseRecordList[i].createDate = new Date(this.CaseRecordList[i].createDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].targetDate != null) {
              this.CaseRecordList[i].targetDate = new Date(this.CaseRecordList[i].targetDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].completeDate != null) {
              this.CaseRecordList[i].completeDate = new Date(this.CaseRecordList[i].completeDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].updateDate != null) {
              this.CaseRecordList[i].updateDate = new Date(this.CaseRecordList[i].updateDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].responseDate != null) {
              this.CaseRecordList[i].responseDate = new Date(this.CaseRecordList[i].responseDate).toISOString().slice(0, 10);
            }

            //Stop Loading Icon when finish fetching last record
            if (i == this.CaseRecordCount) {
              this.AutoReload = false;
            }
          }
        } else {
          this.AutoReload = false;
        }
      });
  }


  //get record by id and assign to selected record
  getCaseDataById(id) {
    this.http.get(this.PrimaryApiPath + id, this.bcp.getHttpOptions())
      //.map((response: Response) => response.json())
      .subscribe((data: any) => {
        this.SelectedCaseRecord = data;

        if (this.SelectedCaseRecord.issueDate) {
          this.SelectedCaseRecord.issueDate = new Date(this.SelectedCaseRecord.issueDate);
        }
        if (this.SelectedCaseRecord.targetDate) {
          this.SelectedCaseRecord.targetDate = new Date(this.SelectedCaseRecord.targetDate);
        }
        if (this.SelectedCaseRecord.completeDate) {
          this.SelectedCaseRecord.completeDate = new Date(this.SelectedCaseRecord.completeDate);
        }
        if (this.SelectedCaseRecord.updateDate) {
          this.SelectedCaseRecord.updateDate = new Date(this.SelectedCaseRecord.updateDate);
        }
        if (this.SelectedCaseRecord.responseDate) {
          this.SelectedCaseRecord.responseDate = new Date(this.SelectedCaseRecord.responseDate);
        }
        if (this.SelectedCaseRecord.resolutionDate) {
          this.SelectedCaseRecord.resolutionDate = new Date(this.SelectedCaseRecord.resolutionDate);
        }

        //convert Y/N value from character to boolean TrueFalse
        this.SelectedCaseRecord.nonCharge = this.bcp.convertYesNoToBoolean(this.SelectedCaseRecord.nonCharge);

        this.CaseListCodeCount = 0;
        this.fetchDropDownValuebyDomian("Edit", this.SelectedCaseRecord.domainId);
        this.CaseListCodeCount = 0;

        //this.ConvertCaseListCodetoDesc("Edit");

      });
  }


  //get record by id and assign to selected record
  getCaseDataonDomainChange(selectedDomain) {
    this.CaseRecordList = null;

    this.http.get(this.PrimaryApiPath + "q/byDomain/" + selectedDomain + "/" + this.bcp.getCurrentDataRole(), this.bcp.getHttpOptions())
      //.map((response: Response) => response.json())
      .subscribe((data: any[]) => {
        this.CaseRecordList = data;
        this.CaseRecordCount = this.CaseRecordList.length;

        if (this.CaseRecordList.length > 0) {
          for (var i = 0; i < this.CaseRecordList.length; i++) {
            if (this.CaseRecordList[i].createDate != null) {
              this.CaseRecordList[i].createDate = new Date(this.CaseRecordList[i].createDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].targetDate != null) {
              this.CaseRecordList[i].targetDate = new Date(this.CaseRecordList[i].targetDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].completeDate != null) {
              this.CaseRecordList[i].completeDate = new Date(this.CaseRecordList[i].completeDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].updateDate != null) {
              this.CaseRecordList[i].updateDate = new Date(this.CaseRecordList[i].updateDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].responseDate != null) {
              this.CaseRecordList[i].responseDate = new Date(this.CaseRecordList[i].responseDate).toISOString().slice(0, 10);
            }

            //Stop Loading Icon when finish fetching last record
            if (i = this.CaseRecordCount) {
              this.AutoReload = false;
            }
          }
        } else {
          this.CaseRecordList = null;
          //this.FormattedCaseRecordList = null;
          this.AutoReload = false;
        }
      });
  }


  //Get record ID for re-direct to edit page when click 'Save and Upload' (For upload Attachment)
  getCaseIDbyData(domainId, caseNumber) {
    this.http.get(this.PrimaryApiPath + "GetID/" + domainId + "/" + caseNumber, this.bcp.getHttpOptions())
      //.map((response: Response) => response.json())
      .subscribe((data: any) => {
        this.record = data;

        this.editRecord(this.record);
      });
  }


  findRecord() {
    this.CaseRecordList = null;
    //this.getCaseDataBySearchField();

    //Initialize Variable for showing loading icon and formatted value
    this.CaseRecordCount = 0;
    this.CaseRecordCurrentCount = 0;
    //this.FormattedCaseRecordList = [];
    this.AutoReload = true;

    this.getCaseData();
  }


  getCaseActivityData(caseDomain, caseId) {
    this.http.get(this.ActivityApiPath + "byCaseId/" + caseDomain + "/" + caseId, this.bcp.getHttpOptions())
      //.map((response: Response) => response.json())
      .subscribe((data: any) => {
        this.ActivityRecordList = data;

        for (var i = 0; i < this.ActivityRecordList.length; i++) {
          //Format Date to YYYY-MM-DD
          if (this.ActivityRecordList[i].createDate != null) {

            this.ActivityRecordList[i].createTime = this.ActivityRecordList[i].createDate.slice(11);
            this.ActivityRecordList[i].createDate = this.ActivityRecordList[i].createDate.slice(0, 10);
          }
          if (this.ActivityRecordList[i].updateDate != null) {
            this.ActivityRecordList[i].updateDate = this.ActivityRecordList[i].updateDate.slice(0, 10);
          }

          this.ActivityRecordList[i].notifyUser = this.bcp.convertYesNoToBoolean(this.ActivityRecordList[i].notifyUser);
        }

        this.ReloadActivity();
      });
  }

  updateConfigTable() {
    this.http.post("api/BcpTableConfig/Update/" + this.bcp.getCurrentDomainId() + "/" + this.CurrentForm, this.bcp.getHttpOptions())
      //.map((response: Response) => response.json())
      .subscribe((data: any) => {
        this.TableConfig = data;

        //Pattern: "BCP" + Current Year + Next Number
        var currentYear = new Date().getFullYear();

        var formattedNextNumber: string;
        formattedNextNumber = this.TableConfig.nextNumber.toString();

        while (formattedNextNumber.length < this.leadingPad)
          formattedNextNumber = "0" + formattedNextNumber;

        this.SelectedCaseRecord.caseNumber = this.TableConfig.prefix + currentYear + formattedNextNumber;

      },
        (err) => {
          this.InputErrorMsg.push({ severity: 'error', summary: 'Error Message', detail: 'Something went wrong' });
        });
  }


  RefreashDropDownonDomainChange(selectedDomain) {
    this.AutoReload = true;

    if (selectedDomain == "" && this.bcp.getCurrentDomainId() != "BCP") {
      selectedDomain = this.bcp.getCurrentDomainId();
    }
    this.fetchDropDownValuebyDomian("Search", selectedDomain);

    this.getCaseDataonDomainChange(selectedDomain);
  }


  GetAllCases() {
    this.AutoReload = true;

    this.http.get(this.PrimaryApiPath + "GetAll/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentDataRole(), this.bcp.getHttpOptions())
      //.map((response: Response) => response.json())
      .subscribe((data: any[]) => {
        this.CaseRecordList = data;
        this.CaseRecordCount = this.CaseRecordList.length;

        if (this.CaseRecordList.length > 0) {
          for (var i = 0; i < this.CaseRecordList.length; i++) {
            //Format Date to YYYY-MM-DD
            if (this.CaseRecordList[i].createDate != null) {
              this.CaseRecordList[i].createDate = new Date(this.CaseRecordList[i].createDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].targetDate != null) {
              this.CaseRecordList[i].targetDate = new Date(this.CaseRecordList[i].targetDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].completeDate != null) {
              this.CaseRecordList[i].completeDate = new Date(this.CaseRecordList[i].completeDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].updateDate != null) {
              this.CaseRecordList[i].updateDate = new Date(this.CaseRecordList[i].updateDate).toISOString().slice(0, 10);
            }
            if (this.CaseRecordList[i].responseDate != null) {
              this.CaseRecordList[i].responseDate = new Date(this.CaseRecordList[i].responseDate).toISOString().slice(0, 10);
            }

            //Stop Loading Icon when finish fetching last record
            if (i == this.CaseRecordCount) {
              this.AutoReload = false;
            }
          }
        } else {
          this.AutoReload = false;
        }
      });
  }

  //20220617 Enhancement Start - Enable Send out Email Function
  CaseActivityRowExpend(event) {
    var selectedCaseId = event.data.id;
    //Add one more parameter to control how many records will be fetch
    var activityRecordCount = 3;
    this.GetLatestActivitiesbyID(selectedCaseId, activityRecordCount, "RowExpend");
  }

  //20210525 Enhancement Start - Row Expansion to display case activities - Jelly
  /*GetLatestActivitiesbyID(event) {
    var selectedCaseId = event.data.id;
    
    this.http.get(this.ActivityApiPath + "latestByCaseId/" + selectedCaseId + "/" + this.activityRecordCount, this.bcp.getHttpOptions())
      .subscribe((data: any[]) => {
        this.latestActivitiesList = data;
      });    
  }*/
  GetLatestActivitiesbyID(caseId, activityRecordCount, Source) {
    this.http.get(this.ActivityApiPath + "latestByCaseId/" + caseId + "/" + activityRecordCount, this.bcp.getHttpOptions())
      .subscribe((data: any[]) => {
        this.latestActivitiesList = data;

        if (Source == "SendEmail") {
          this.emailContext = this.latestActivitiesList[0];

          this.sendActivityEmail(this.emailContext);
        }
      });
  }
  //20210525 Enhancement End
  //20220617 Enhancement End

  //20230119 Enhancement Start - Add 2 Global Filter
  clearGlobalFilter() {
    this.globalFilterValue1 = "";
    this.globalFilterValue2 = "";
    this.globalFilterValue3 = "";
    this.globalFilterValue4 = "";
  }

  applyGlobalFilter() {
    var element = document.getElementById('globalFilter1');
    var event = new Event('input');

    element = document.getElementById('globalFilter1');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter2');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter3');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter4');
    element.dispatchEvent(event);
  }
  //20230119 Enhancement End



  //-----------------------------------------------------------------------------
  //                                  Attachment
  //-----------------------------------------------------------------------------

  ClickUpload() {
    this.ShowUploadForm = true;
    this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.saveButton = false;
  }


  //-----Upload Attachment for each record-----
  //20210524 Fix start - Change from Standard Upload to Custom Upload
  //set file object for upload when file is selected
  selectUploadFile(event: any) {
    for (let file of event.files) {
      this.uploadFile = file;
    }
  }

  /*selectUploadFile(event: any) {

    //this.uploadFile = event.target.files[0];
    let fi = event.srcElement;
    if (fi.files && fi.files[0]) {
      this.uploadFile = fi.files[0];
    }
  }*/
  //20210524 Enhancement End


  //when 'upload attachment' button clicked
  /*processUploadFile(sourceRecordId: any, event: any) {

      //let fi = event.srcElement;
      //if (fi.files && fi.files[0]) {
      if (this.uploadFile) {
          //let fileToUpload = fi.files[0];

          var filePrefix: String;
          filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
          filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

          let fileToUpload = this.uploadFile;
          let formData: FormData = new FormData();

          formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
          formData.append("DomainId", this.bcp.getCurrentDomainId());
          formData.append("SourceTableName", "BcpCase");
          formData.append("SourceRecordId", sourceRecordId);
          formData.append("UpdateUser", this.bcp.getCurrentLoginUser());
          

          let headers = new Headers();
          // DON'T SET THE Content-Type to multipart/form-data, You'll get the Missing content-type boundary error
          let options = new RequestOptions({ headers: this.bcp.getHttpHeaderAtt() });

          this.http.post("api/BcpAttachment/" + sourceRecordId, formData, options)
              .subscribe(r => {
                  console.log(r);

                  this.SuccessUpload = true;
                  this.AttachmentAutoReload = false;                    
                  this.getAttachmentList(sourceRecordId);
                  this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
                  
              });            
      }

      if (this.SuccessUpload == true) {
          //alert('Upload Successfully');
          
      }
  }*/

  //20210524 Fix start - Change from Standard Upload to Custom Upload
  //set file object for upload when file is selected
  //upload the selected attachment
  processUploadFile(sourceRecordId: any) {

    this.SuccessUpload = false;
    this.AttachmentAutoReload = false;

    //let fi = event.srcElement;
    //if (fi.files && fi.files[0]) {
    if (this.uploadFile) {

      //let fileToUpload = fi.files[0];
      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.bcp.getCurrentDomainId());
      formData.append("SourceTableName", "Case");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();
      // DON'T SET THE Content-Type to multipart/form-data,
      //You'll get the Missing content-type boundary error
      //let options = new RequestOptions();

      this.http.post("api/BcpAttachment/" + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe(r => {
          console.log(r);

          this.SuccessUpload = true;
          //this.AttachmentAutoReload = false;
          this.getAttachmentList(sourceRecordId);
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
        });
    }

    /*if (this.SuccessUpload == true) {
      //alert("Attachment Upload Successfully");
      //this.uploadFile = null;
      this.getAttachmentList(sourceRecordId);
    }*/
  }
  //20210524 Fix End


  /*downloadFile(recordID, fileName) {
      this.http.get('api/BcpAttachment/File/' + recordID, { headers: this.bcp.getHttpHeader(), responseType: ResponseContentType.Blob })
          .catch((err) => { return Observable.throw(err.json()); })
          .subscribe((res: Response) => {
              if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
                  var blob = new Blob([res.blob()]);
                  window.navigator.msSaveOrOpenBlob(blob, fileName);
              } else {
                  var a = document.createElement("a");
                  a.href = URL.createObjectURL(res.blob());
                  a.download = fileName;
                  // start download
                  a.click();
              }
          })
  }*/

  //download attachment by click on the filename
  downloadFile(recordID, fileName) {
    //this.http.get(this.AttachmentPath + "File/" + recordID, { 'responseType': 'blob'} )
    this.http.get('api/BcpAttachment/File/' + recordID, this.bcp.getHttpOptionsAtt())
      .catch((err) => { return Observable.throw(err); })
      .subscribe((result: any) => {
        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
          console.log("window" + result);
          var blob = new Blob([result]);
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          console.log("other" + result);

          var a = document.createElement("a");
          var blob = new Blob([result]);
          a.href = URL.createObjectURL(result);
          a.download = fileName;
          // start download
          a.click();
        }
      })
  }

  //20210524 Fix start - Change from Standard Upload to Custom Upload
  //set file object for upload when file is selected
  //-----Load Attachment List of case-----
  //to get attachment list
  getAttachmentList(recordID) {
    this.AttachmentList = [];

    this.http.get(this.AttachmentPath + "List/" + this.bcp.getCurrentDomainId() + "/Case/" + recordID, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.AttachmentList = result;
        //console.log("aatachment " + this.AttachmentList);

        if (this.AttachmentList.length > 0) {
          this.AttachmentAutoReload = true;
        }
      });
  }
  //20210524 Fix End

  deleteAttachment(recordID) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete attachment?',
      accept: () => {
        this.http.delete("api/BcpAttachment/Delete/" + recordID, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.getAttachmentList(this.SelectedCaseRecord.id);

            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File deleted successfully' }];
          });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //-----------------------------------------------------------------------------
  //                                  Export Data
  //-----------------------------------------------------------------------------

  extractData(res: string) {
    // transforme response to blob
    let myBlob: Blob = new Blob([res], { type: 'application/forcde-download' }); // replace the type by whatever type is your response

    var fileURL = URL.createObjectURL(myBlob);
    // Cross your fingers at this point and pray whatever you're used to pray
    window.open(fileURL);
  }


  async generateExcelReport() {
    let caseRec: ICase;
    let caseList: ICase[];

    let fileReader = new FileReader();
    let strLine: string;
    let timeStamp: string;
    const url = "https://sheetjs.com/data/executive.json";

    //get the tender master data
    caseList = this.CaseRecordList;
    timeStamp = this.bcp.convertDateToString(null, true).toString();

    //initial the worksheet and workbook
    //this.strLine = "";
    //this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "TenderReport");

    //if then else for easy to collapase the contents only
    //Header Fields
    if (1 == 1) {
      //---------------------------------------------
      //List Headings
      //---------------------------------------------
      if (this.FormAccessRight == "RW") {
        this.strLine = "Domain~Case No.~Status~ Request User~ Assigned To~ Subject~ Description~ Resolution";
        this.strLine = this.strLine + "~ Remarks~ Severity~ Service Type~ Source~ Category~ Sub - Category1";
        this.strLine = this.strLine + "~ Sub - Category2~ Sub - Category3~ Create Date~ Response Date";
        this.strLine = this.strLine + "~ Complete Date~ Onsite Hours~ Offsite Hours";
        this.strLine = this.strLine + "~ Last Update Date~ Last Update User";
      } else {
        this.strLine = "Domain~Case No.~Status~ Request User~ Subject~ Description~ Resolution";
        this.strLine = this.strLine + "~ Severity~ Service Type~ Source~ Category~ Sub - Category1";
        this.strLine = this.strLine + "~ Sub - Category2~ Sub - Category3~ Create Date";
        this.strLine = this.strLine + "~ Complete Date";
      }

      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    //output the record details
    for (var i = 0; i < caseList.length; i++) {

      if (this.FormAccessRight == "RW") {
        this.strLine = "" + caseList[i].domainId
          + "~" + caseList[i].caseNumber + "~" + caseList[i].caseStatusDesc
          + "~" + caseList[i].requestUser + "~" + caseList[i].assignedToDesc
          + "~" + caseList[i].subject + "~" + caseList[i].longDescription
          + "~" + caseList[i].resolution + "~" + caseList[i].remarks
          + "~" + caseList[i].severityDesc + "~" + caseList[i].serviceTypeDesc
          + "~" + caseList[i].sourceDesc + "~" + caseList[i].categoryDesc
          + "~" + caseList[i].subCat1Desc + "~" + caseList[i].subCat2Desc
          + "~" + caseList[i].subCat3Desc + "~" + caseList[i].createDate
          + "~" + caseList[i].responseDate + "~" + caseList[i].completeDate
          + "~" + caseList[i].onSiteHour + "~" + caseList[i].offSiteHour
          + "~" + caseList[i].updateDate + "~" + caseList[i].updateUser;
      } else {
        this.strLine = "" + caseList[i].domainId
          + "~" + caseList[i].caseNumber + "~" + caseList[i].caseStatusDesc
          + "~" + caseList[i].requestUser + "" + ""
          + "~" + caseList[i].subject + "~" + caseList[i].longDescription
          + "~" + caseList[i].resolution + "" + ""
          + "~" + caseList[i].severityDesc + "~" + caseList[i].serviceTypeDesc
          + "~" + caseList[i].sourceDesc + "~" + caseList[i].categoryDesc
          + "~" + caseList[i].subCat1Desc + "~" + caseList[i].subCat2Desc
          + "~" + caseList[i].subCat3Desc + "~" + caseList[i].createDate
          + "" + "" + "~" + caseList[i].completeDate
          + "" + "" + "" + ""
          + "" + "" + "" + "";
      }


      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    this.fixWidth(worksheet);
    this.applyCellFormat(worksheet);

    XLSX.writeFile(workbook, "CaseList_" + timeStamp + ".xlsx", { compression: true });
  }

  //Formet Excel Cell
  fixWidth(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 8 }, { width: 14 }, { width: 14 }, { width: 20 }, { width: 20 }, //ABCDE
      { width: 30 }, { width: 30 }, { width: 30 }, { width: 25 }, { width: 10 }, //FGHIJ
      { width: 20 }, { width: 15 }, { width: 20 }, { width: 20 }, { width: 20 }, //KLMNO
      { width: 20 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, //PQRST
      { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 } //UVWXYZ
    ];
    worksheet["!cols"] = wscols;

    this.lastRowNumber = data.length + 1;
  }



  applyCellFormat(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];

    //bold
    this.addRangeToCellList("A", 1, "W", 1, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.addRangeToCellList("A", 1, "W", 1, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    tmpList = [];
    this.addRangeToCellList("A", 1, "W", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //amount with 2dp
    //aware if any space before the cell value
    tmpList = ["C5"];
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };

  col(columnName1: string): string {
    let result: string;
    result = (columnName1.trim().charCodeAt(0) - 65).toString();
    return result;
  }

  colIndexToChar(colIndex) {
    let result: string = "";
    let adjustFlag = (colIndex - (Math.floor(colIndex / 26) * 26)) === 0 ? 1 : 0; // for AZ/BZ ... handling

    if (colIndex <= 26) {
      result = String.fromCharCode(colIndex + 64);
    } else {
      result = String.fromCharCode(Math.floor((colIndex - adjustFlag) / 26) + 64); //assume max column is ZZ
      result = result + String.fromCharCode(colIndex - (Math.floor((colIndex - adjustFlag) / 26) * 26) + 64);
    }
    return result;
  }

  charToColIndex(colName) {
    let result = 0;
    if (colName.length == 1) {
      result = colName.charCodeAt(0) - 64
    } else {
      result = (colName[0].charCodeAt(0) - 64) * 26;
      result = result + colName[1].charCodeAt(0) - 64;
    }
    return result;
  }

  addListToCellList(extraList: string[], appendFlag) {
    if (!appendFlag || this.cellList == null || this.cellList == undefined) {
      this.cellList = [];
    }
    this.cellList = this.cellList.concat(extraList);
  }

  addRangeToCellList(startCol, startRow, endCol, endRow, appendFlag) {
    let startColIndex = this.charToColIndex(startCol);
    let endColIndex = this.charToColIndex(endCol);
    let currCell: string;
    if (!appendFlag || this.cellList == null || this.cellList == undefined) {
      this.cellList = [];
    }

    for (let c = startColIndex; c <= endColIndex; c++) {
      for (let r = startRow; r <= endRow; r++) {
        this.cellList.push(this.colIndexToChar(c) + r);
      }

    }
  }

  updateExcelRow() {
    const colIndexArray = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    let dataArray: string[];
    this.excelRow = [];
    dataArray = this.strLine.split("~");
    //console.log("string is " + dataArray);
    for (let index = 0; index < dataArray.length; index += 1) {
      this.excelRow[index] = dataArray[index];
    }
  }

  formatCell(worksheet: XLSX.WorkSheet, localCellList: string[]
    , formatRule: string) {

    let defaultStyle = {
      font: {
        bold: false,
        italic: false,
        underline: false
      },
      border: {
        top: { style: "none", color: { auto: 1 } },
        right: { style: "none", color: { auto: 1 } },
        bottom: { style: "none", color: { auto: 1 } },
        left: { style: "none", color: { auto: 1 } }
      }
    };

    let newStyle = JSON.parse(JSON.stringify(defaultStyle));
    let originalStyle = JSON.parse(JSON.stringify(defaultStyle));

    const fontSetting01 = {
      bold: true,
      italic: false,
      underline: false
    };

    const borderSetting01 = {
      top: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } }
    };

    const bgcolorSetting01 = {
      patternType: "solid",
      fgColor: { rgb: "e6f7eb" }
    }

    for (let i = 0; i < localCellList.length; i++) {
      //cache the original style of the cell

      if (worksheet[localCellList[i]] !== undefined) {
        if (formatRule === "BOLD" || formatRule === "BORDER"
          || formatRule === "BGCOLOR_01") {
          newStyle = JSON.parse(JSON.stringify(defaultStyle));
          originalStyle = JSON.parse(JSON.stringify(defaultStyle));
          if (worksheet[localCellList[i]].s !== undefined) {
            originalStyle = JSON.parse(JSON.stringify(worksheet[localCellList[i]].s));
          }

          if (originalStyle.font !== undefined) {
            newStyle.font = originalStyle.font;
          }
          if (originalStyle.border !== undefined) {
            newStyle.border = originalStyle.border;
          }
          if (originalStyle.fill !== undefined) {
            newStyle.fill = originalStyle.fill;
          }

          if (formatRule === "BOLD") {
            newStyle.font = fontSetting01;
          }

          if (formatRule === "BORDER") {
            newStyle.border = borderSetting01;
          }

          if (formatRule === "BGCOLOR_01") {
            newStyle.fill = bgcolorSetting01;
          }

          worksheet[localCellList[i]].s = newStyle;
        }

        if (formatRule === "AMOUNT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "_($* #,##0.00_);_($* (#,##0.00);_($* -??_);_(@_)";
        }

        if (formatRule === "NUMBER") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00";
        }

        if (formatRule === "NUMBER_4DP") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.0000";
        }

        if (formatRule === "PERCENT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00%";
        }
      } else {
        console.log("Error when Formatting Cell " + localCellList[i]);
      }
    }



  }//formatCell end



  //-----------------------------------------------------------------------------
  //                      Add/Edit/Save/Delete Records
  //-----------------------------------------------------------------------------

  //Re-direct from add page to edit page to upload attachment
  saveThenUploadAttachment() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to save this record?',
      accept: () => {
        this.uploadAttachment = true;
        //Convert Description to Code List for Saveing Record to DB
        this.CaseListCodeCount = 0;
        this.preProcessingAndSave();
        //this.ConvertCaseDesctoListCode("", "Save");
      },
      reject: () => {
        //Do Nothing
      }
    });
  }

  //Return to Inquiry Form
  saveThenFindRecord() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to save this record?',
      accept: () => {
        this.uploadAttachment = false;
        this.CaseListCodeCount = 0;
        this.preProcessingAndSave();

      },
      reject: () => {
        //Do Nothing
      }
    });

  }


  addCaseRecord() {
    //initialize the SelectedRecord as a new record, and assign default value as required
    this.SelectedCaseRecord = null;
    this.initializeSelectedRow();

    //Auto Generate Case Number base on Current Domain ID
    //this.updateConfigTable();

    //set default value 
    //this.SelectedCaseRecord.domainId = this.bcp.getCurrentDomainId();
    this.SelectedCaseRecord.caseNumber = "";
    this.SelectedCaseRecord.caseType = "";
    this.SelectedCaseRecord.category = "";
    this.SelectedCaseRecord.subCategory1 = "";
    this.SelectedCaseRecord.subCategory2 = "";
    this.SelectedCaseRecord.subCategory3 = "";
    this.SelectedCaseRecord.businessUnit = "";
    this.SelectedCaseRecord.referenceNumber = "";
    this.SelectedCaseRecord.subject = "";
    this.SelectedCaseRecord.description = "";
    this.SelectedCaseRecord.longDescription = "";
    this.SelectedCaseRecord.resolution = "";
    this.SelectedCaseRecord.remarks = "";
    this.SelectedCaseRecord.comment = "";
    this.SelectedCaseRecord.caseStatus = "P";
    this.SelectedCaseRecord.severity = "";
    this.SelectedCaseRecord.serviceType = "";
    this.SelectedCaseRecord.caseComplexity = "";
    this.SelectedCaseRecord.source = "";
    this.SelectedCaseRecord.requestUser = "";
    this.SelectedCaseRecord.endUser = "";
    this.SelectedCaseRecord.issueDate = new Date(this.bcp.getCurrentUTCDateTime());
    this.SelectedCaseRecord.targetDate = "";
    this.SelectedCaseRecord.responseDate = "";
    this.SelectedCaseRecord.resolutionDate = "";
    this.SelectedCaseRecord.completeDate = "";
    this.SelectedCaseRecord.fiscalYear = 0;
    this.SelectedCaseRecord.periodNumber = 0;
    this.SelectedCaseRecord.assignedTo = "";
    this.SelectedCaseRecord.onSiteHour = "";
    this.SelectedCaseRecord.offSiteHour = "";
    this.SelectedCaseRecord.assignedTo2 = "";
    this.SelectedCaseRecord.onSiteHour2 = "";
    this.SelectedCaseRecord.offSiteHour2 = "";
    this.SelectedCaseRecord.projectId = "";
    this.SelectedCaseRecord.clientReferenceNumber = "";
    this.SelectedCaseRecord.technicalRemark = "";
    this.SelectedCaseRecord.responseHour = 0;
    this.SelectedCaseRecord.resolutionHour = 0;
    this.SelectedCaseRecord.consultManDay = "";
    this.SelectedCaseRecord.nonCharge = true;
    this.SelectedCaseRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedCaseRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedCaseRecord.cancelUser = "";
    this.SelectedCaseRecord.cancelDate = "";
    this.SelectedCaseRecord.updateUser = "";
    this.SelectedCaseRecord.updateDate = "";

    this.AttachmentList = null;

    this.FormTitle = "Case Revision";
    this.ShowAddForm = true;
    this.ShowEditForm = false;
    this.ShowUploadForm = false;

    this.fetchDropDownValuebyDomian("Add", this.bcp.getCurrentDomainId());
    //20211104 Enhancement Start - Update Fields according to the Case Status
    //this.enableCompleteDateReadonly(this.SelectedCaseRecord.caseStatus);
    this.autoFillbyCaseStatus(this.SelectedCaseRecord.caseStatus);
    //20211104 Enhancement End
  }


  editRecord(recordId) {
    this.getCaseDataById(recordId);
    this.getAttachmentList(recordId);

    this.initializeActivityVariable();
    this.getCaseActivityData(this.SelectedCaseRecord.domainId, recordId);

    this.FormTitle = "Case Revision";// - ID = " + recordId;
    this.ShowAddForm = false;
    this.ShowEditForm = true;
    this.ShowUploadForm = false;
  }


  saveRecord() {
    this.SuccessfulSave = false;
    this.InputErrorMsg = [];

    //Convert DateTime format to Date only
    if (this.SelectedCaseRecord.issueDate) {
      this.SelectedCaseRecord.issueDate = this.bcp.convertCalendarDateTimeToJson(this.SelectedCaseRecord.issueDate);
    }
    if (this.SelectedCaseRecord.targetDate) {
      this.SelectedCaseRecord.targetDate = this.bcp.convertCalendarDateTimeToJson(this.SelectedCaseRecord.targetDate);
    }
    if (this.SelectedCaseRecord.completeDate) {
      this.SelectedCaseRecord.completeDate = this.bcp.convertCalendarDateTimeToJson(this.SelectedCaseRecord.completeDate);
    }
    if (this.SelectedCaseRecord.responseDate) {
      this.SelectedCaseRecord.responseDate = this.bcp.convertCalendarDateTimeToJson(this.SelectedCaseRecord.responseDate);
    }
    if (this.SelectedCaseRecord.resolutionDate) {
      this.SelectedCaseRecord.resolutionDate = this.bcp.convertCalendarDateTimeToJson(this.SelectedCaseRecord.resolutionDate);
    }

    //convert check box field value from boolean to character
    this.SelectedCaseRecord.nonCharge = this.bcp.convertBooleanToYesNo(this.SelectedCaseRecord.nonCharge);

    //set update date and update user
    this.SelectedCaseRecord.updateDate = this.bcp.getCurrentDateTime();
    this.SelectedCaseRecord.updateUser = this.bcp.getCurrentLoginUser();

    //convert request and end user to upper case
    this.SelectedCaseRecord.requestUser = this.bcp.upper(this.SelectedCaseRecord.requestUser);
    this.SelectedCaseRecord.endUser = this.bcp.upper(this.SelectedCaseRecord.endUser);

    this.stringifyValue = JSON.stringify(this.SelectedCaseRecord);

    //Insert Record
    if (this.SelectedCaseRecord.id == 0) {
      this.http.post(this.PrimaryApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        //.map(res => res.json())
        .subscribe(
          (data: any) => {
            this.SuccessfulSave = true;

            if (this.uploadAttachment == true) {
              this.ShowAddForm = false;
              this.ShowEditForm = true;
              this.ShowUploadForm = false;
              this.FormTitle = "Case Revision";
              this.getCaseIDbyData(this.SelectedCaseRecord.domainId, this.SelectedCaseRecord.caseNumber);
              //this.getCaseActivityData(this.SelectedCaseRecord.id);


              this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Record created successfully' }];

            } else {
              this.ShowAddForm = false;
              this.ShowEditForm = false;
              this.ShowUploadForm = false;
              this.FormTitle = "Work With Case";
              this.findRecord();

              //Clear Search Form Error Message
              this.clearAllMessage();
              this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Record created successfully' }];
              this.initializeSelectedRow();
              this.fetchDropDownValuebyDomian("Search", this.bcp.getCurrentDomainId())
            }
          });
    }
    //Update Record
    else {
      this.http.put(this.PrimaryApiPath + this.SelectedCaseRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        //.map(res => res.json())
        .subscribe(
          (data: any) => {
            //20221213 Enhancement Start - Send Email when Case Status Changed - Jelly
            if (this.originalCaseStatus != this.SelectedCaseRecord.caseStatus) {
              if (JSON.parse(sessionStorage.getItem("enableCaseStatusEmail")) == "true") {
                this.confirmSendCaseStatusEmail();
              }
            }
            //20221213 Enhancement End

            if (this.SelectedActivityRecord.activityDetail) {
              //Get List Code for saving
              this.saveCaseActivity(this.SelectedCaseRecord.domainId, this.SelectedCaseRecord.caseNumber, "Exit");
              //this.getCaseCodebyDesc("", "Activity", "ASSIGNEE", this.SelectedActivityRecord.notifyUserList);
              this.initializeSelectedRow();

            } else {
              this.SuccessfulSave = true;

              this.ShowAddForm = false;
              this.ShowEditForm = false;
              this.ShowUploadForm = false;
              this.AttachmentList = null;
              this.FormTitle = "Work With Case";
              this.findRecord();

              //Clear Search Form Error Message
              this.clearAllMessage();
              this.fetchDropDownValuebyDomian("Search", this.bcp.getCurrentDomainId());
            }
          })
    }

    //Return Desc to Drop Down List if error found
    if (this.InputErrorMsg) {
      //this.ConvertCaseListCodetoDesc("Edit");
    }
  }

  handleSaveActivityAction(Action) {
    this.confirmationService.confirm({
      message: 'Are you sure to save activity?',
      key: 'ConfirmSave',
      header: 'Confirmation',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.checkActivityBlankContent(Action);
      },
      reject: () => {
        //Do Nothing
      }
    });
  }

  //20220617 Enhancement Start - Enable Send out Email Function
  checkActivityBlankContent(Action) {
    if (this.SelectedActivityRecord.activityDetail.trim() == "") {
      this.confirmationService.confirm({
        message: 'Activity Detail section is blank, are you sure to save a blank activity?',
        key: 'ConfirmSaveBlank',
        header: 'Confirmation',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.startCheckSaveActivity(Action);
        },
        reject: () => {
          //Do Nothing
        }
      });
    } else {
      this.startCheckSaveActivity(Action);
    }
  }
  //20220617 Enhancement End

  //Insert new record into Case Activity table each time inputted
  saveCaseActivity(caseDomain, caseNumber, Action) {
    //20220617 Enhancement Start - Enable Send out Email Function
    this.activityAction = Action;
    //20220617 Enhancement End

    this.stringifyValue = "";

    this.SelectedActivityRecord.domainId = caseDomain;
    this.SelectedActivityRecord.caseNumber = caseNumber;
    //set update date and update user
    this.SelectedActivityRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedActivityRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedActivityRecord.updateUser = this.bcp.getCurrentLoginUser();
    this.SelectedActivityRecord.updateDate = this.bcp.getCurrentDateTime();

    //convert check box field value from boolean to character
    this.SelectedActivityRecord.notifyUser = this.bcp.convertBooleanToYesNo(this.SelectedActivityRecord.notifyUser);

    this.stringifyValue = JSON.stringify(this.SelectedActivityRecord);

    this.http.post(this.ActivityApiPath, this.stringifyValue, this.bcp.getHttpOptions())
      //.map(res => res.json())
      .subscribe(
        (data: any) => {
          //20220617 Enhancement Start - Enable Send out Email Function
          if (this.SelectedActivityRecord.notifyUser == "Y") {
            if (JSON.parse(sessionStorage.getItem("CaseActivityEnable")) == "true") {
              var activityRecordCount = 1;
              this.GetLatestActivitiesbyID(this.SelectedCaseRecord.id, activityRecordCount, "SendEmail");
            } else {
              this.redirectActivityAfterSave(this.activityAction);
            }
          } else {
            this.redirectActivityAfterSave(this.activityAction);
          }
          //20220617 Enhancement End
        });
  }

  //20220617 Enhancement Start - Enable Send out Email Function
  redirectActivityAfterSave(Action) {
    this.savingActivity = false;
    this.savingActivityMsg = "";

    if (Action == "Exit") {
      this.SuccessfulSave = true;

      this.ShowAddForm = false;
      this.ShowEditForm = false;
      this.ShowUploadForm = false;
      this.AttachmentList = null;
      this.FormTitle = "Work With Case";


      this.findRecord();

      //Clear Search Form Error Message
      this.clearAllMessage();

      if (this.SelectedActivityRecord.notifyUser == "Y") {
        if (JSON.parse(sessionStorage.getItem("CaseActivityEnable")) == "true") {
          if (this.emailReturnStatus == true) {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Activity record saved successfully and Email had been sent out' }];
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Activity record saved successfully but failed to send out email, please contact CS for details' }];
          }
        } else {
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Activity record saved successfully' }];
        }
      } else {
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Activity record saved successfully' }];
      }
      this.fetchDropDownValuebyDomian("Search", this.bcp.getCurrentDomainId());
    }
    if (Action == "Edit") {
      this.SuccessfulSave = true;

      //this.ShowAddForm = false;
      //this.ShowEditForm = true;
      //this.ShowUploadForm = false;
      this.AttachmentList = null;
      this.FormTitle = "Case Revision";

      //this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Activity record saved successfully' }];
      if (this.SelectedActivityRecord.notifyUser == "Y") {
        if (this.emailReturnStatus == true) {
          this.emailReturnMsg.push({ severity: 'success', summary: 'Confirm Message', detail: 'Activity record saved successfully and Email had been sent out' });
        } else {
          this.emailReturnMsg.push({ severity: 'error', summary: 'Confirm Message', detail: 'Activity record saved successfully but failed to send out email' });
        }
      } else {
        this.emailReturnMsg.push({ severity: 'success', summary: 'Confirm Message', detail: 'Activity record saved successfully' });
      }

      this.getCaseActivityData(this.SelectedActivityRecord.domainId, this.SelectedCaseRecord.id);
      this.initializeActivityVariable();
    }
  }
  //20220617 Enhancement End


  initializeActivityVariable() {
    //initialize the SelectedRecord as a new record, and assign default value as required
    this.SelectedActivityRecord = null;
    this.SelectedActivityRecord = JSON.parse('{"id": 0}');

    this.SelectedActivityRecord.domainId = this.bcp.getCurrentDomainId();
    this.SelectedActivityRecord.caseNumber = "";
    this.SelectedActivityRecord.createUser = "";
    this.SelectedActivityRecord.createDate = "";
    this.SelectedActivityRecord.activityDetail = "";
    this.SelectedActivityRecord.notifyUser = false;
    this.SelectedActivityRecord.notifyUserList = "";
    this.SelectedActivityRecord.updateDate = "";
    this.SelectedActivityRecord.updateUser = "";

    //20220617 Enhancement Start - Enable Send out Email Function
    this.activityEmailDisable = true;
    this.emailList = [];
    this.emailValidResult = false;
    this.emailContext = null;
    this.emailReturnStatus = false;
    //20220617 Enhancement End
  }


  //20210525 Fix Start - Prompt Message before Delete Case
  deleteRecord(pId) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete case?',
      accept: () => {
        this.http.delete(this.PrimaryApiPath + pId, this.bcp.getHttpOptions())
          //.map(res => res.json())
          .subscribe(
            (data: any) => {
              this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Record deleted' }];

              this.initializeSelectedRow();
              this.findRecord();
              this.fetchDropDownValuebyDomian("Search", this.bcp.getCurrentDomainId());
            });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }
  //20210525 Fix End


  deleteActivityRecord(pId) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete activity?',
      accept: () => {
        this.http.delete(this.ActivityApiPath + pId, this.bcp.getHttpOptions())
          //.map(res => res.json())
          .subscribe(
            (data: any) => {
              this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Activity Record deleted' }];

              this.getCaseActivityData(this.SelectedCaseRecord.domainId, this.SelectedCaseRecord.id);
              this.initializeActivityVariable();
            });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  cancel() {
    this.findRecord();
    this.SelectedCaseRecord = null;
    this.AttachmentList = null;
    this.initializeActivityVariable();
    //this.SearchStaffFieldHolder = [];

    this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.ShowUploadForm = false;
    this.FormTitle = "Work With Case";

    //Clear Search Form Error Message
    this.clearAllMessage();
    this.initializeSelectedRow();
    this.fetchDropDownValuebyDomian("Search", this.bcp.getCurrentDomainId());

  }

  RefreashDropDown(selectedDomain) {
    this.SelectedCaseRecord.category = "";
    this.SelectedCaseRecord.subCategory1 = "";
    this.SelectedCaseRecord.subCategory2 = "";
    this.SelectedCaseRecord.subCategory3 = "";

    this.fetchDropDownValuebyDomian("Add", selectedDomain);
  }

  //-----------------------------------------------------------------------------
  //                      Checking/ Other Actions
  //-----------------------------------------------------------------------------

  //sorting event trigger, default is sorting by id
  changeSort(event) {
    if (!event.order) {
      this.sortF = 'id';
    } else {
      this.sortF = event.field;
    }
  }


  //Re-assign Value (Y/N to True/False) to CheckBox after failure save
  assignValueforCheckBox() {
    this.SelectedCaseRecord.nonCharge = this.bcp.convertYesNoToBoolean(this.SelectedCaseRecord.nonCharge);
  }


  checkRadioButtonChecked(form) {
    //Clear Search Form Error Message
    this.clearAllMessage();

    if (this.SelectedCaseRecord.id && this.SelectedCaseRecord.id > 0) {
      if (form == "Edit") {
        this.editRecord(this.SelectedCaseRecord.id);
      }
      if (form == "Delete") {
        this.confirmationService.confirm({
          message: 'Are you sure that you want to delete?',
          accept: () => {
            this.deleteRecord(this.SelectedCaseRecord.id);

          },
          reject: () => {
            this.resultMsgs = [{ severity: 'info', summary: 'Rejected', detail: 'You have rejected' }];
          }
        });
      }
    } else {
      this.searchErrorMsgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please select a record' });
    }
  }

  clearAllMessage() {
    this.searchErrorMsgs = [];
    this.InputErrorMsg = [];
    this.resultMsgs = [];
    this.emailReturnMsg = [];
  }

  initializeSelectedRow() {
    this.SelectedCaseRecord = JSON.parse('{"id": 0}');
  }

  ReloadActivity() {
    this.ShowAddForm = false;
    this.ShowEditForm = true;
    this.ShowUploadForm = false;
  }

  async preProcessingAndSave() {
    //clear error message
    this.clearAllMessage();
    this.checkedError = 'N';

    //check domain
    if (this.SelectedCaseRecord.domainId.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Domain is missing   ' });
    };

    //check issue date and get fiscal year / period
    if (!this.SelectedCaseRecord.issueDate) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Issue Date is missing   ' });
    } else {
      this.SelectedCaseRecord.fiscalYear = this.SelectedCaseRecord.issueDate.getFullYear();
      this.SelectedCaseRecord.periodNumber = this.SelectedCaseRecord.issueDate.getMonth() + 1;
    };

    //check subject
    if (this.SelectedCaseRecord.subject.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Subject is missing   ' });
    };

    //check category
    if (this.SelectedCaseRecord.category.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Category is missing   ' });
    };

    //check subcategory 1
    if (this.SelectedCaseRecord.subCategory1.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Subcategory 1 is missing   ' });
    };

    //check severity
    if (this.SelectedCaseRecord.severity.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Severity is missing   ' });
    };

    //check service type
    if (this.SelectedCaseRecord.serviceType.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Service Type is missing   ' });
    };

    //check source
    if (this.SelectedCaseRecord.source.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Source is missing   ' });
    };

    //check description
    if (this.SelectedCaseRecord.longDescription.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Description is missing   ' });
    };

    //check hour inputs are numeric
    this.checkNumericInput(this.SelectedCaseRecord.onSiteHour);
    if (this.numericCheck == false) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Onsite Hour should be numeric   ' });
    }
    this.checkNumericInput(this.SelectedCaseRecord.offSiteHour);
    if (this.numericCheck == false) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Offsite Hour should be numeric   ' });
    }
    this.checkNumericInput(this.SelectedCaseRecord.onSiteHour2);
    if (this.numericCheck == false) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Onsite Hour should be numeric   ' });
    }
    this.checkNumericInput(this.SelectedCaseRecord.offSiteHour2);
    if (this.numericCheck == false) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Offsite Hour should be numeric   ' });
    }

    //when case is completed
    if (this.SelectedCaseRecord.caseStatus == "D") {
      //check resolution input
      if (this.SelectedCaseRecord.resolution.trim() == "") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Resolution is missing   ' });
      };
      //check create date is less than complete date
      var issueDate;
      var completeDate;
      issueDate = new Date(this.SelectedCaseRecord.issueDate).toISOString().slice(0, 10);
      completeDate = new Date(this.SelectedCaseRecord.completeDate).toISOString().slice(0, 10);
      if (issueDate > completeDate) {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Complete Date should be greater than Issue Date   ' });
      }
    }

    //get response hour
    if (this.SelectedCaseRecord.responseDate) {
      this.SelectedCaseRecord.responseHour = this.getHoursBetween(this.SelectedCaseRecord.issueDate, this.SelectedCaseRecord.responseDate);
    }

    //get resolution hour
    if (this.SelectedCaseRecord.resolutionDate) {
      this.SelectedCaseRecord.resolutionHour = this.getHoursBetween(this.SelectedCaseRecord.issueDate, this.SelectedCaseRecord.resolutionDate);
    }

    //assign case number if above checking passed
    if (this.checkedError == 'N') {
      if (this.SelectedCaseRecord.caseNumber.trim() == "") {
        await this.genNextNumber('BCP', 'CA01', this.SelectedCaseRecord.issueDate)
        if (this.NextNumberOutput.nextKey == "NOT_FOUND") {
          this.checkedError = 'Y';
          this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Default Next Number is not setup   ' });
        } else if (this.NextNumberOutput.nextKey == "MAX_NUMBER") {
          this.checkedError = 'Y';
          this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Maximum Next Number is reached   ' });
        } else {
          this.SelectedCaseRecord.caseNumber = this.NextNumberOutput.nextKey;
        }
      };
    }

    //check unique if above checking passed
    if (this.checkedError == 'N') {
      let tmpApiString1: string = "";
      tmpApiString1 = JSON.stringify(this.SelectedCaseRecord);
      //console.log("sstring is" + tmpApiString1);
      let checkResult1 = await this.http.post(this.PrimaryApiPath + "ValidateKeyFields/", tmpApiString1, this.bcp.getHttpOptions())
        .map((response: any) => JSON.parse(response.toString())).toPromise();
      if (checkResult1.validFlag == "N") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Case Number is duplicated   ' });
      }
    };

    //save record finally if no error
    if (this.checkedError == 'N') {
      this.saveRecord();
    };

  }


  autoFillbyCaseStatus(caseStatus) {
    if (caseStatus == "D") {
      this.completeDateReadonly = false;
      if (!this.SelectedCaseRecord.completeDate) {
        this.SelectedCaseRecord.completeDate = new Date(this.bcp.getCurrentUTCDateTime());
      }
    } else {
      this.completeDateReadonly = true;
      this.SelectedCaseRecord.completeDate = "";
    }
    if (caseStatus == "W") {
      //if (!this.SelectedCaseRecord.responseDate) {
      //  this.SelectedCaseRecord.responseDate = new Date(this.bcp.getCurrentUTCDateTime());
      //}
    } else {
      if (caseStatus == "P") {
        this.SelectedCaseRecord.responseDate = "";
      }
    }

    this.updatedCaseStatus = caseStatus;
  }



  autoUpdateTargetDate(severity) {

    this.http.get(this.SeverityPath + "ResolutionBySeverity/" + severity, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        var ResolutionTime = result;

        if (this.SelectedCaseRecord.targetDate == "") {
          var newTargetDate = new Date(this.bcp.getCurrentUTCDateTime());
          newTargetDate.setDate(newTargetDate.getDate() + parseInt(ResolutionTime));

          this.SelectedCaseRecord.targetDate = newTargetDate;
        } else {
          var newTargetDate = new Date(this.SelectedCaseRecord.issueDate);
          newTargetDate.setDate(newTargetDate.getDate() + parseInt(ResolutionTime));

          this.SelectedCaseRecord.targetDate = newTargetDate;
        }

      });
  }



  checkNumericInput(numeric) {
    this.numericCheck = false;

    if (isNaN(Number(numeric))) {
      this.numericCheck = false;
    } else {
      this.numericCheck = true;
    }
  }


  //getNextNumber for new record
  async genNextNumber(domainId: string, tableKey: string, inputDate: any) {
    this.NextNumberOutput = null;
    this.NextNumberOutput = JSON.parse('{"id": 0}');
    this.GenNextNumberFieldHolder = null;
    this.GenNextNumberFieldHolder = JSON.parse('{"id": 0}');
    this.GenNextNumberFieldHolder.domainId = domainId;
    this.GenNextNumberFieldHolder.tableKey = tableKey;
    this.GenNextNumberFieldHolder.inputDate = inputDate;
    this.GenNextNumberFieldHolder.updateUser = this.bcp.getCurrentLoginUser();
    this.GenNextNumberFieldHolder.updateDate = this.bcp.getCurrentDateTime();
    this.stringifyValue = JSON.stringify(this.GenNextNumberFieldHolder);
    //console.log("FieldHolder is " + this.stringifyValue);
    this.NextNumberOutput = await this.http.post(this.TableSequenceApiPath + "GenNextNumber/", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    //console.log("NextNumberOutput is " + this.NextNumberOutput);
    //console.log("nextKey is " + this.NextNumberOutput.nextKey);
  }


  isHoliday(date: Date): boolean {
    date.setHours(date.getHours() + 8); // add 8 hours to offset UTC
    const dateStr = date.toISOString().split('T')[0]; // 'YYYY-MM-DD'
    date.setHours(date.getHours() - 8); // add 8 hours to offset UTC
    return this.hkHolidays.includes(dateStr);
  }


  getHoursBetween(startDate: Date, endDate: Date): number {
  if (endDate <= startDate) return 0;

  // Office hours start and end (in 24h format)
  const officeStartHour = 9;
  const officeEndHour = 17;

  let totalOfficeHours = 0;

  // Clone dates to avoid mutation
  let current = new Date(startDate);

    while (current < endDate) {
      const dayOfWeek = current.getDay();
    // Check if current day is a weekday (Monday=1 to Friday=5)
      if (dayOfWeek >= 1 && dayOfWeek <= 5 && !this.isHoliday(current)) {
        // Calculate office hours for this day

        // Create Date objects for office start and end on this day
        const officeStart = new Date(current);
        officeStart.setHours(officeStartHour, 0, 0, 0);

        const officeEnd = new Date(current);
        officeEnd.setHours(officeEndHour, 30, 0, 0);

        // Calculate the overlap between [startDate, endDate] and [officeStart, officeEnd]
        const intervalStart = startDate > officeStart ? startDate : officeStart;
        const intervalEnd = endDate < officeEnd ? endDate : officeEnd;

        if (intervalEnd > intervalStart) {
          const diffMs = intervalEnd.getTime() - intervalStart.getTime();
          const diffHours = diffMs / (1000 * 60 * 60);
          totalOfficeHours += diffHours;
        }
      }

    // Move to next day at 00:00
    current.setDate(current.getDate() + 1);
    current.setHours(0, 0, 0, 0);
  }

  return totalOfficeHours;
}


  setResolutionDate() {
    if (this.SelectedCaseRecord.resolution) {
      if (!this.SelectedCaseRecord.resolutionDate) {
        this.SelectedCaseRecord.resolutionDate = new Date(this.bcp.getCurrentUTCDateTime());
      }
    } else {
      this.SelectedCaseRecord.resolutionDate = "";
    }
  }

  //-----------------------------------------------------------------------------
  //                      Email Functions
  //-----------------------------------------------------------------------------
  enableEmailSend() {
    if (this.SelectedActivityRecord.notifyUser === true) {
      this.activityEmailDisable = false;

      this.getDefaultRecipient();
    } else {
      this.activityEmailDisable = true;
      this.SelectedActivityRecord.notifyUserList = "";
    }
  }

  getDefaultRecipient() {
    this.defaultEmailRecipients = "";

    var endUser = this.SelectedCaseRecord.endUser.replace(" ", "-");
    //var endUser = this.SelectedCaseRecord.endUser;

    this.http.get(this.EmailRecipientsPath + "GetRecipientsbyName/" + this.SelectedCaseRecord.domainId + "/" + endUser, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.defaultEmailRecipients = result;

        this.SelectedActivityRecord.notifyUserList = this.defaultEmailRecipients;
      })
  }

  startCheckSaveActivity(Action) {
    this.savingActivity = true;
    if (Action == "Edit") {
      if (this.SelectedActivityRecord.notifyUser == true) {
        this.savingActivityMsg = "Saving and Sending Email..."
      } else {
        this.savingActivityMsg = "Saving Activity..."
      }
    }

    if (this.SelectedActivityRecord.notifyUser == true) {
      this.confirmSendActivityEmail(this.SelectedActivityRecord.notifyUserList)
    }

    this.saveCaseActivity(this.SelectedCaseRecord.domainId, this.SelectedCaseRecord.caseNumber, Action);
  }

  confirmSendActivityEmail(inputtedEmail) {
    this.emailReturnMsg = [];

    if (inputtedEmail) {
      this.validActivityEmailRecipient(inputtedEmail);
    } else {
      this.emailReturnMsg.push({ severity: 'error', summary: 'Error Message', detail: 'Please input at least one email recipient' });

      this.savingActivity = false;
      this.savingActivityMsg = "";
    }
  }

  validActivityEmailRecipient(inputtedEmail) {
    //For checking inputted value is in valid email format
    var emailRegex = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$");
    var invalidFound: number = 0;

    //Replace "," as Email Separator
    inputtedEmail = inputtedEmail.replace(",", ";");
    this.emailList = inputtedEmail.split(";");

    //Check if each inputted email in valid format
    for (let i = 0; i < this.emailList.length - 1; i++) {
      this.emailValidResult = emailRegex.test(this.emailList[i].toString());
      if (this.emailValidResult) {
        invalidFound = invalidFound;
      } else {
        invalidFound = invalidFound + 1;
      }
    }

    if (invalidFound > 0) {
      this.emailReturnMsg.push({ severity: 'error', summary: 'Error Message', detail: 'Please input valid email address for recipent(s)' });
    }
  }

  sendActivityEmail(emailContext) {
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(emailContext);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendCaseActivityEmail/" + this.bcp.getCurrentDomainId().toString() + "/" + this.bcp.getCurrentLoginUser().toString(), this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;

        this.redirectActivityAfterSave(this.activityAction);
      },
        (err) => {
          this.emailReturnStatus = false;

          this.redirectActivityAfterSave(this.activityAction);
        });
  }
  //20220617 Enhancement End

  //20221213 Enhancement Start - Send Email when Case Status Changed - Jelly
  confirmSendCaseStatusEmail() {
    this.clearCaseStatusEmail();

    this.getCaseStatusEmailContent();
  }

  clearCaseStatusEmail() {
    this.caseStatusEmail = {};

    this.caseStatusEmail.loginDomain = this.bcp.getCurrentDomainId();
    this.caseStatusEmail.loginUser = this.bcp.getCurrentLoginUser();
    this.caseStatusEmail.caseDomain = "";
    this.caseStatusEmail.caseNumber = "";
    this.caseStatusEmail.caseEndUser = "";
    this.caseStatusEmail.caseFromStatus = "";
    this.caseStatusEmail.caseToStatus = "";
  }

  getCaseStatusEmailContent() {
    this.caseStatusEmail.loginDomain = this.bcp.getCurrentDomainId();
    this.caseStatusEmail.loginUser = this.bcp.getCurrentLoginUser();
    this.caseStatusEmail.caseDomain = this.SelectedCaseRecord.domainId;
    this.caseStatusEmail.caseNumber = this.SelectedCaseRecord.caseNumber;
    this.caseStatusEmail.caseEndUser = this.SelectedCaseRecord.endUser;
    this.caseStatusEmail.caseFromStatus = this.originalCaseStatus;
    this.caseStatusEmail.caseToStatus = this.updatedCaseStatus;

    this.sendCaseStatusEmail();
  }

  sendCaseStatusEmail() {
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.caseStatusEmail);
    alert(this.stringifyValue);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendCaseStatusEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Case updated and email had been sent out to end user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Case updated but failed to sent out email to end user' }];
        });
  }
}


interface ICase {
  id?;
  domainId?;
  caseNumber?;
  caseType?;
  category?;
  categoryDesc?;
  subCategory1?,
  subCat1Desc?;
  subCategory2?;
  subCat2Desc?;
  subCategory3?;
  subCat3Desc?;
  businessUnit?;
  referenceNumber?;
  subject?;
  description?;
  longDescription?;
  resolution?;
  remarks?;
  comment?;
  caseStatus?;
  caseStatusDesc?;
  severity?;
  severityDesc?;
  serviceType?;
  serviceTypeDesc?;
  caseComplexity?;
  caseComplexityDesc?;
  source?;
  sourceDesc?;
  requestUser?;
  endUser?;
  issueDate?;
  targetDate?;
  responseDate?;
  resolutionDate?;
  completeDate?;
  fiscalYear?;
  periodNumber?;
  assignedTo?;
  assignedToDesc?;
  onSiteHour?;
  offSiteHour?;
  assignedTo2?;
  onSiteHour2?;
  offSiteHour2?;
  projectId?;
  clientReferenceNumber?;
  technicalRemark?;
  responseHour?;
  resolutionHour?;
  consultManDay?;
  nonCharge?;
  createUser?;
  createDate?;
  cancelUser?;
  cancelDate?;
  updateDate?;
  updateUser?;
  //non database

}

interface ICaseActivity {
  id?;
  domainId?;
  caseNumber?;
  createDate?;
  createTime?;
  createUser?;
  activityDetail?;
  notifyUser?;
  notifyUserList?;
  updateDate?;
  updateUser?;
}

interface IDomainValue {
  label?;
  value?;
}

interface ICodeValue {
  label?;
  value?;
}

interface IDomainUserValue {
  label?;
  value?;
}

interface IAttachmentValue {
  filePath?;
  id?;
  domainId?;
  sourceTable?;
  sourceRecordId?;
  actualFileName?;
  displayName?;
  createDate?;
  updateUser?;
  updateDate?;
}


interface ITableConfig {
  domain?;
  sourceTable?;
  prefix?;
  nextNumber?;
}

interface Message {
}

interface INotifyEmailList {
}

interface ICaseStatusEmail {
  loginDomain?;
  loginUser?;
  caseDomain?;
  caseNumber?;
  caseEndUser?;
  caseFromStatus?;
  caseToStatus?;
}

interface IGenNextNumber {
  domainId?;
  tableKey?;
  year?;
  inputDate?;
  updateUser?;
  updateDate?;
}

interface INextNumber {
  nextNumber?;
  nextKey?;
}
